// 混合拆单第二单的跨页记录（会员站本地）：只记录 pclid、品名、预估金额与关联订单号，不存地址明细。
// 会员站与后端接口都没有拆单关联字段，所以第一单付款后续建第二单、我的訂單提醒与兩單結果页都靠这份记录串起来。
import * as storageUtils from '@g/utils/storageUtils'

export const SPLIT_ORDER_STATUS = Object.freeze({
  FIRST_CREATED: 'first-created',
  FIRST_PAID: 'first-paid',
  SECOND_CREATED: 'second-created',
})

const SPLIT_ORDER_TTL_MINUTES = 60 * 24 * 30

function normalizePclids (pclids) {
  if (Array.isArray(pclids)) return pclids.map(String).filter(Boolean)
  if (typeof pclids === 'string') return pclids.split(',').map(item => item.trim()).filter(Boolean)
  return []
}

export function readSplitOrderRecord ({ uid } = {}) {
  const record = storageUtils.get('kkrenJyorderSplitPending')
  if (!record || typeof record !== 'object') return null
  if (uid != null && String(record.uid) !== String(uid)) return null
  return record
}

export function writeSplitOrderRecord (record) {
  const next = {
    version: 1,
    createdAt: Date.now(),
    ...record,
    pclids: normalizePclids(record?.pclids),
  }
  storageUtils.set('kkrenJyorderSplitPending', next, SPLIT_ORDER_TTL_MINUTES)
  return next
}

export function updateSplitOrderRecord (patch, { uid } = {}) {
  const current = readSplitOrderRecord({ uid })
  if (!current) return null
  return writeSplitOrderRecord({ ...current, ...patch })
}

export function clearSplitOrderRecord () {
  storageUtils.remove('kkrenJyorderSplitPending')
}

export function isSplitSecondPending (record) {
  return Boolean(record && record.status !== SPLIT_ORDER_STATUS.SECOND_CREATED && normalizePclids(record.pclids).length)
}

// 当前勾选的包裹是否就是待建的第二单：勾选必须与记录里的例外件完全一致（多选或少选都不算，
// 否则第一单取消后重新勾选全部包裹会被误认成第二单）。
export function findPendingSplitSecondRecord ({ uid, pclids } = {}) {
  const record = readSplitOrderRecord({ uid })
  if (!isSplitSecondPending(record)) return null
  if (pclids != null) {
    const selected = new Set(normalizePclids(pclids))
    const expected = new Set(record.pclids)
    if (selected.size !== expected.size || ![...expected].every(pclid => selected.has(pclid))) return null
  }
  return record
}

// 订单已取消／已退款即视为作废，拆单记录不再有意义。
export function isSplitOrderVoid (order) {
  return ['0', '2'].includes(String(order?.jyoPayStatus))
}

// 取消订单成功后同步记录：取消的是第一单或第二单都直接清掉（流程结束，之后按普通订单处理）。
export function syncSplitRecordAfterCancel (oid, { uid } = {}) {
  const record = readSplitOrderRecord({ uid })
  if (!isSplitFirstOrder(record, oid) && !isSplitSecondOrder(record, oid)) return false
  clearSplitOrderRecord()
  return true
}

export function isSplitFirstOrder (record, oid) {
  return Boolean(record && oid && String(record.firstOid) === String(oid))
}

export function isSplitSecondOrder (record, oid) {
  return Boolean(record && oid && record.secondOid && String(record.secondOid) === String(oid))
}
